import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router";
import HCPAccessLogo from "../HCPAccessLogo";
import UserProfileMenu from "./UserProfileMenu";
import { useAppSelector } from "../../stores";
import { Endpoints } from "../../routes";
import NavLinks from "./NavLinks";
import "./Navbar.css";
const Navbar = () => {
    const currentUser = useAppSelector(state => state.auth.currentUser);
    const isAuthenticated = currentUser !== null;
    if (!isAuthenticated)
        return null;
    return (_jsxs("nav", Object.assign({ className: "navbar" }, { children: [_jsx("div", Object.assign({ className: "navbar_left" }, { children: _jsx(Link, Object.assign({ to: Endpoints.ROOT }, { children: _jsx(HCPAccessLogo, {}) })) })), _jsx("div", { className: "navbar_center" }), _jsxs("div", Object.assign({ className: "navbar_right" }, { children: [_jsx(NavLinks, {}), _jsx(UserProfileMenu, { email: currentUser.email })] }))] })));
};
export default Navbar;
